import type { InputHTMLAttributes } from 'react';

import { inputStyle } from './input';

export type CheckboxProps = {
  loading?: boolean;
  error?: boolean;
  disabled?: boolean;
} & Omit<InputHTMLAttributes<HTMLInputElement>, 'type' | 'value'>;
export function Checkbox({
  className,
  error,
  loading,
  disabled,
  ...props
}: CheckboxProps) {
  const style = checkboxStyle({
    error,
    loading,
    disabled,
  });

  return (
    <div className={style.container({ className })}>
      <input
        {...props}
        type="checkbox"
        className={style.input({
          className: 'size-0 px-2',
        })}
      />
    </div>
  );
}

export const checkboxStyle = inputStyle;
